export function redirect(query, router, queryKey="redirect") {
    const _redirectPath = query[queryKey]
    return function(route){
        if(!!_redirectPath) router.replace(_redirectPath)
        else if(!!route) router.push(route)
        else router.back()
    }
}